import React, { Component } from 'react';

class appointmentForm extends Component{
	render(){
		return(
			<>
				
				<div className="appointment-form form-wraper">
					<h3 className="title">Agendar Asesoría Financiera</h3>
					<form action="#">
						<div className="form-group">
							<select className="form-select form-control">
								<option defaultValue>Selecciona el tipo de asesoría</option>
								<option defaultValue="1">Inversión</option>
								<option defaultValue="2">Crédito</option>
								<option defaultValue="3">Ahorro</option>
							</select>
						</div>
						<div className="form-group">
							<select className="form-select form-control">
								<option defaultValue>Selecciona Asesor</option>
								<option defaultValue="1">El shak</option>
								<option defaultValue="2">Otro compa</option>
								<option defaultValue="3">Una IA</option>
							</select>
						</div>
						<div className="form-group">
							<input type="text" className="form-control" placeholder="Tú nombre"/>
						</div>
						<div className="form-group">
							<input type="number" className="form-control" placeholder="Algún Teléfono"/>
						</div>
						<div className="form-group">
							<input type="date" className="form-control" placeholder="Fecha"/>
						</div>
						<button type="submit" className="btn btn-secondary btn-lg">Agendar Asesoría</button>
					</form>
				</div>
			
			</>
		);
	}
}

export default appointmentForm;